/**
 * Returns a color tier string based on time remaining until expiry.
 * @param {string|null|undefined} availableUntil - ISO date string
 * @returns {'green'|'orange'|'red'|null}
 */
export function getColorTier(availableUntil) {
  if (!availableUntil) return null;
  const ms = new Date(availableUntil).getTime() - Date.now();
  if (ms <= 0) return 'red';
  if (ms > 86400000) return 'green';
  if (ms >= 3600000) return 'orange';
  return 'red';
}

/**
 * Breaks milliseconds into countdown segments.
 * @param {number} ms
 * @returns {{ days: number, hours: number, minutes: number, seconds: number }}
 */
export function formatCountdown(ms) {
  if (ms <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  const totalSeconds = Math.floor(ms / 1000);
  const days    = Math.floor(totalSeconds / 86400);
  const hours   = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { days, hours, minutes, seconds };
}
